import React from "react";
import { Project } from "./types";
// "Select a project": year · team — full preprint title, searchable by any
// of the three. The chosen project's full title is shown underneath so a
// long title never depends on a tooltip.
export function projectLabel(p: Project) {
  return p.year + " · " + p.team + (p.title ? " — " + p.title : "");
}
export default function ProjectPicker({
  projects,
  value,
  onChange,
  label = "Select a project",
  status,
  disabled = false,
  allowNone = false,
}: {
  projects: Project[];
  value: string;
  onChange: (id: string) => void;
  label?: string;
  status?: (p: Project) => string;
  disabled?: boolean;
  allowNone?: boolean;
}) {
  const [filter, setFilter] = React.useState("");
  const q = filter.trim().toLowerCase();
  const shown = projects.filter(
    (p) => !q || projectLabel(p).toLowerCase().includes(q) || p.id === value,
  );
  const chosen = projects.find((p) => p.id === value);
  return (
    <div className="er-project-picker">
      <label>
        {label}
        <input
          type="search"
          placeholder="Filter by year, team or title"
          value={filter}
          disabled={disabled}
          onChange={(e) => setFilter(e.target.value)}
          aria-label={label + ": filter"}
        />
      </label>
      <select
        aria-label={label}
        value={value}
        disabled={disabled}
        size={Math.min(8, Math.max(2, shown.length + 1))}
        onChange={(e) => onChange(e.target.value)}
      >
        <option value="">{allowNone ? "No project" : "Choose…"}</option>
        {shown.map((p) => (
          <option key={p.id} value={p.id}>
            {projectLabel(p)}
            {status ? " · " + status(p) : ""}
          </option>
        ))}
      </select>
      {chosen && (
        <div className="er-project-detail">
          <div className="er-kicker">
            iDEC {chosen.year} · {chosen.team}
            {status ? " · " + status(chosen) : ""}
          </div>
          {chosen.preprints && chosen.preprints.length ? (
            chosen.preprints.map((a) => (
              <p key={a.articleId}>
                <a href={"/article/" + a.articleId + "/"} target="_blank" rel="noopener noreferrer">
                  {a.title}
                </a>
              </p>
            ))
          ) : (
            <p>No published preprint linked to this Wiki.</p>
          )}
          <a href={chosen.wikiUrl} target="_blank" rel="noopener noreferrer">
            Team Wiki ↗
          </a>
        </div>
      )}
    </div>
  );
}
